import React, { FC, ReactElement } from "react";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";
import packageJson from "../../package.json";

function Footer() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        paddingTop: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box sx={{ width: "100%" }} />
          <Box sx={{ width: "100%", textAlign: "center" }}>
            <Typography color="textSecondary" variant="subtitle1">
              <CopyrightIcon sx={{ mb: "-6px" }} />
              {new Date().getFullYear()} |
              <Link href="https://obrienwritescode.com" sx={{ ml: 1 }}>
                obrienwritescode.com
              </Link>{" "}
              |
              <Typography component="span" sx={{ ml: 1 }}>
                {packageJson.version}
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
